import React from 'react';
import './CareerPathway.css';

const CareerPathway = () => {
  const employers = [
    { name: 'Boeing', icon: '🏢' },
    { name: 'Lockheed Martin', icon: '🏢' },
    { name: 'Delta Airlines', icon: '🏢' },
    { name: 'United Airlines', icon: '🏢' },
    { name: 'American Airlines', icon: '🏢' },
    { name: 'Southwest Airlines', icon: '🏢' }
  ];

  return (
    <section className="career-pathway" id="careers">
      <div className="container">
        <div className="pathway-layout">
          <div className="pathway-left">
            <h3 className="section-header">YOUR JOURNEY</h3>
            <h2 className="section-title">
              CAREER <span className="title-highlight">PATHWAY</span>
            </h2>
            <p className="section-description">
              A structured 6-year program that takes you from aspiring pilot to airline-ready professional with substantial experience.
            </p>
            
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-marker">Y1</div>
                <div className="timeline-content">
                  <h3>YEAR 1: CPL + BSC FIRST YEAR</h3>
                  <p>Complete your Commercial Pilot License (CPL) training and first year of BSc Aeronautics coursework.</p>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-marker">Y2-3</div>
                <div className="timeline-content">
                  <h3>YEAR 2 & 3: CFI, CFII + GRADUATION</h3>
                  <p>Earn CFI and CFII certifications. Fly as instructor at the flying school. Complete your BSc graduation.</p>
                  <div className="milestone">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <span>1000+ Hours at Graduation</span>
                  </div>
                </div>
              </div>
              
              <div className="timeline-item">
                <div className="timeline-marker">Y4-6</div>
                <div className="timeline-content">
                  <h3>YEAR 4 TO 6: AIRLINE PILOT CAREER</h3>
                  <p>Three years as a pilot in any US airline with assured job placement through the flying school.</p>
                  <div className="milestone">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <span>Total 4000+ Hours</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pathway-right">
            <div className="usa-opportunities">
              <img 
                src="/images/usa-skyline.jpg" 
                alt="USA Career Opportunities" 
                onError={(e) => e.target.src = 'https://via.placeholder.com/560x380/1e3a8a/ffffff?text=USA+Skyline'}
              />
            </div>

            <div className="employers">
              <h3>TOP EMPLOYERS HIRING</h3>
              <div className="employer-grid">
                {employers.map((employer, index) => (
                  <div className="employer-item" key={index}>
                    <span className="employer-icon">{employer.icon}</span>
                    <span className="employer-name">{employer.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerPathway;
